import React, { ReactElement } from "react";
import { OptionSelect } from "./OptionSelect";

/**
 * Sammlung von Standard-Auswahlmenüs (OptionSelect) auf einer Seite
 * Optional mit custom Children ganz unten
 * @param title Titel der Seite
 * @param optionen Namen der Auswahlen (Füllung, ...)
 * @param optionenTitleKeys optional, custom titel für die einzelnen Auswahlen
 * @param hide soll nicht angezeigt werden
 * @param children beliebiege Elemente, die unten dargestellt werden, z.B. für Darstllungen oder andere Auswahlen
 */
export function OptionPage({
  title,
  optionen,
  optionenTitleKeys,
  hide = false,
  children,
}: {
  title: string;
  optionen: string[];
  optionenTitleKeys?: string[];
  hide?: boolean;
  children?: ReactElement;
}) {
  if (hide) return <></>;

  return (
    <section id={`content_${title}`} className="optionContent" role="region" aria-label={title}>
      <div role="group" aria-label={I18N("aria::Konfigurationsoptionen")}>
        {optionen.map((option, index) => (
          <OptionSelect
            key={option}
            optionKey={option}
            optionTitleKey={optionenTitleKeys && optionenTitleKeys[index]}
          ></OptionSelect>
        ))}
      </div>
      {children}
    </section>
  );
}
